var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2585 7.5L14.6404 2.11812C15.1199 1.63863 15.1199 0.839362 14.6404 0.359614C14.1609 -0.119871 13.3616 -0.119871 12.8819 0.359614L7.5 5.74149L2.11812 0.359614C1.63863 -0.119871 0.839362 -0.119871 0.359614 0.359614C-0.119871 0.8391 -0.119871 1.63837 0.359614 2.11812L5.74149 7.5L0.359614 12.8819C-0.119871 13.3614 -0.119871 14.1606 0.359614 14.6404C0.8391 15.1199 1.63837 15.1199 2.11812 14.6404L7.5 9.2585L12.8819 14.6404C13.3614 15.1199 14.1606 15.1199 14.6404 14.6404C15.1199 14.1609 15.1199 13.3616 14.6404 12.8819L9.2585 7.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXSign);
export default __webpack_public_path__ + "static/media/xSign.bf043d7ea65e822b5307f82998b9af77.svg";
export { ForwardRef as ReactComponent };